import React from 'react'
import { Container } from 'semantic-ui-react';
import {db} from '../../firebase'
import moment from 'moment';
import useObtenerServiciosAcivos from '../../hooks/obtenerServiciosAcivos';

const Installer = () => {
//Collecciones
    //const {servicios } = useObtenerServiciosAcivos()
    const [usuarios, setUsuarios ] = React.useState(false)
    const [accountants, setAccountants ] = React.useState(false)
    const [availableplans, setAvailableplans ] = React.useState(false)
    const [availableservicesType, setAvailableservicesType ] = React.useState(false)
    const [availableservices, setAvailableservices ] = React.useState(false)
    const [codeservices, setCodeservices ] = React.useState(false)
    const [coments, setComents ] = React.useState(false)
    const [companies, setCompanies ] = React.useState(false)
    const [contactsGlobal, setContactsGlobal ] = React.useState(false)
    const [orders, setOrders ] = React.useState(false)
    const [paymentmethods, setPaymentmethods ] = React.useState(false)
    const [paymentoptions, setPaymentoptions ] = React.useState(false)
    const [products, setProducts ] = React.useState(false)
    const [purchasesummaries, setPurchasesummaries ] = React.useState(false)
    const [rates, setRates ] = React.useState(false)
    const [roles, setRoles ] = React.useState(false)
    const [ServiceType,setServiceType] = React.useState(false)
    const [balance, setBalance ] = React.useState(false)
    const [billing, setBilling ] = React.useState(false)
    const [globalBilling, setGlobalBilling ] = React.useState(false)
    const [GlobalBillinghistory, setGlobalBillinghistory ] = React.useState(false)
    const [cars, setCars ] = React.useState(false)
    const [typesPackes,setTypesPackes] = React.useState(false)
    const [typesVehicles,setTypesVehicles] = React.useState(false)
    const [typesVehiclesTypes,setTypesVehiclesTypes] = React.useState(false)  
    const [driversRoutes,setDriversRoutes] = React.useState(false)  





    const [element, setElement ] = React.useState('')
    React.useEffect(() => {
        findColleccecionInFirebase()

      }, [element])

    React.useEffect(()=>{

    },[])

    const installerGlobalBsic = async () => {
        console.log('intstalacion recursiva')
    } 



    const findColleccecionInFirebase =async()=>{
        try {
            var table = await db.collection(`${process.env.REACT_APP_COL_VEHICLES}`)
            .get();
            if(table.docs.length >0){
                setTypesVehicles(true)   
            }
        } catch (error) {
            setTypesVehicles(false)  
        }
        try {
            var tablex = await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`)
            .get();
            if(tablex.docs.length >0){
                setTypesVehiclesTypes(true)   
            }
        } catch (error) {
            setTypesVehiclesTypes(false)  
        }
        try {
            var table1a2 = await db.collection(`${process.env.REACT_APP_COL_ROUTES}`)
            .get();
            if(table1a2.docs.length >0){
                setDriversRoutes(true)   
            }
        } catch (error) {
            setDriversRoutes(false)  
        }

    try {
        var table1b3 = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
        .get();
        if(table1b3.docs.length >0){
            setUsuarios(true)   
        }
    } catch (error) {
        setUsuarios(false)  
    }

    try {
        var table2 = await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`)
        .get();
        if(table2.docs.length >0){
            setAccountants(true)   
        }
    } catch (error) {
        setAccountants(false)  
    }
    try {
        var table3 = await db.collection(`${process.env.REACT_APP_COL_AVIABLEPLANS}`)
        .get();
        if(table3.docs.length >0){
            setAvailableplans(true)   
        }
    } catch (error) {
        setAvailableplans(false)  
    }
    try {
        var table4 = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_ARTYPE}`)
        .get();
        if(table4.docs.length >0){
            setAvailableservicesType(true)   
        }
    } catch (error) {
        setAvailableservicesType(false)  
    }

    try {
        var table411 = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`)
        .get();
        if(table411.docs.length >0){
            setAvailableservices(true)   
        }
    } catch (error) {
        setAvailableservices(false)  
    }
  
    try {
        var table42 = await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`)
        .get();
        if(table42.docs.length >0){
          //  setAvailableservices(true)   
        }
    } catch (error) {
      //  setAvailableservices(false)  
    }

    try {
        var table41 = await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERVTYPE}`)
        .get();
        if(table41.docs.length >0){
            setServiceType(true)   
        }
    } catch (error) {
        setServiceType(false)  
    }
    

    try {
        var table5 = await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`)
        .get();
        if(table5.docs.length >0){
            setCodeservices(true)   
        }
    } catch (error) {
        setCodeservices(false)  
    }
    try {
        var table6 = await db.collection(`${process.env.REACT_APP_COL_COMENTS}`)
        .get();
        if(table6.docs.length >0){
            setComents(true)   
        }
    } catch (error) {
        setComents(false)  
    }
    try {
        var table7 = await db.collection(`${process.env.REACT_APP_COL_COMPANIES}`)
        .get();
        if(table7.docs.length >0){
            setCompanies(true)   
        }
    } catch (error) {
        setCompanies(false)  
    }
    try {
        var table8 = await db.collection(`${process.env.REACT_APP_COL_CONTACTS}`)
        .get();
        if(table8.docs.length >0){
            setContactsGlobal(true)   
        }
    } catch (error) {
        setContactsGlobal(false)  
    }
    try {
        var table9 = await db.collection(`${process.env.REACT_APP_COL_ORDERS}`)
        .get();
        if(table9.docs.length >0){
            setOrders(true)   
        }
    } catch (error) {
        setOrders(false)  
    }
    try {
        var table10 = await db.collection(`${process.env.REACT_APP_COL_PAYMETHODS}`)
        .get();
        if(table10.docs.length >0){
            setPaymentmethods(true)   
        }
    } catch (error) {
        setPaymentmethods(false)  
    }
    
    try {
        var table11 = await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`)
        .get();
        if(table11.docs.length >0){
            setPaymentoptions(true)   
        }
    } catch (error) {
        setPaymentoptions(false)  
    }
    try {
        var table12 = await db.collection(`${process.env.REACT_APP_COL_PRODUCTS}`)
        .get();
        if(table12.docs.length >0){
            setProducts(true)   
        }
    } catch (error) {
        setProducts(false)  
    }
    try {
        var table13 = await db.collection(`${process.env.REACT_APP_COL_SUMARIES}`)
        .get();
        if(table13.docs.length >0){
            setPurchasesummaries(true)   
        }
    } catch (error) {
        setPurchasesummaries(false)  
    }
    try {
        var table14 = await db.collection(`${process.env.REACT_APP_COL_RATES}`)
        .get();
        if(table14.docs.length >0){
            setRates(true)   
        }
    } catch (error) {
        setRates(false)  
    }
    try {
        var table15 = await db.collection(`${process.env.REACT_APP_COL_ROLES}`)
        .get();
        if(table15.docs.length >0){
            setRoles(true)   
        }
    } catch (error) {
        setRoles(false)  
    }
    try {
        var table16 = await db.collection(`${process.env.REACT_APP_COL_BALANCE}`)
        .get();
        if(table16.docs.length >0){
            setBalance(true)   
        }
    } catch (error) {
        setBalance(false)  
    }
    try {
        var table17 = await db.collection(`${process.env.REACT_APP_COL_BILLING}`)
        .get();
        if(table17.docs.length >0){
            setBilling(true)   
        }
    } catch (error) {
        setBilling(false)  
    }
    try {
        var table18 = await db.collection(`${process.env.REACT_APP_COL_GLOBALBILLING}`)
        .get();
        if(table18.docs.length >0){
            setGlobalBilling(true)   
        }
    } catch (error) {
        setGlobalBilling(false)  
    }

    try { // history
        var table181 = await db.collection(`${process.env.REACT_APP_COL_BILLING}`).doc('dumyCompanybillingAccount').collection('history')
        .get();
        if(table181.docs.length >0){
            setGlobalBillinghistory(true)   
        }
    } catch (error) {
        setGlobalBillinghistory(false)  
    }

    try {
        var table19 = await db.collection(`${process.env.REACT_APP_COL_CARS}`)
        .get();
        if(table19.docs.length >0){
            setCars(true)   
        }
    } catch (error) {
        setCars(false)  
    }

    try {
        var table20 = await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`)
        .get();
        if(table20.docs.length >0){
            setTypesPackes(true)   
        }
    } catch (error) {
        setTypesPackes(false)  
    }
    }

    

    const createColleccionFirebase = async (e) => {
        // console.log(e.target.value)
        var accion = e.target.value
        setElement(accion)
        // // console.log((process.env.REACT_APP_COL_USERS))
        // // console.log(dumy)
        if(accion === 'usuarios'){
         try {
            var model = {
                variable : "valor",
                variable2 : "valor2",
                }        
            await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc().set(model);
            // console.log("Collecion creada");
               } catch (error) {
              // console.log(error);
            }
        }

        if(accion === 'accountants'){
            try {
               var model2 = {count:0}        
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('commentsCounter').set(model2);
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('availableplans').set(model2);
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('ordersCounter').set(model2);
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('xpressProducts').set(model2);
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('purchaseSummaries').set(model2);
               await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('routesCounter').set(model2);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        
        if(accion === 'availableplans'){
              
              // await db.collection(`${process.env.REACT_APP_COL_AVIABLEPLANS}`).doc('PLAN3').set(model3);
              // console.log("Collecion availableplans creada");
           
        }
        if(accion === 'availableservicesType'){
            try {
               var model4 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_ARTYPE}`).doc().set(model4);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'availableservices'){
            // console.log('availableservices')
            try {
               var serv001 = {
                descripcion:
                `Se realizan despachos de mercadería entre dos puntos dentro de la ciudad. Retiro de punto A con destino punto B .`,
                id:"001",
                isActive:true,
                name:"Despacho Punto a Punto",
                   }  
                var serv002 = {
                    descripcion:"Despachos en 24 horas desde la compra de tu cliente.",
                    id:"002",
                    isActive:true,
                    name:"Next Day Delivery",
                       }
                var serv003 = {
                    descripcion:"Se realizan despachos de mercadería entre dos puntos dentro de la ciudad. Retiro de punto A con destino punto B .",
                    id:"003",
                    isActive:true,
                    name:" Same Day Delivery",
                } 
                var serv004 = {
                    descripcion:"Retiramos las devoluciones y las llevamos a la tienda o centro de distribución.",
                    id:"004",
                    isActive:true,
                    name:"Logistica Reversa",
                }                 
                var serv005 = {
                    descripcion:"Cuéntanos tus necesidades y buscamos una solución en conjunto.",
                    id:"005",
                    isActive:true,
                    name:" Soluciones a Medida",
                } 
                var serv006 = {
                    descripcion:"Personal para gestionar parte o la totalidad de los procesos de despacho y entrega.",
                    id:"006",
                    isActive:false,
                    name:"Operador E-BIEX "
                } 
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('001').set(serv001);
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('002').set(serv002);
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('003').set(serv003);
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('004').set(serv004);
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('005').set(serv005);
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`).doc('006').set(serv006);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'ServiceType'){
            try {
               var model41 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERVTYPE}`).doc().set(model41);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'codeservices'){
            try {
                var develop = {
                    active:true,
                    code:"develop",
                    name:"develop",
                }
       
                var serv01= {
                    active:true,
                    code:"serv01",
                    name:"Mi Dashboard",
                }
                var serv02= {
                    active:true,
                    code:"serv02",
                    name:"envío express",
                }
                var serv03= {
                    active:true,
                    code:"serv03",
                    name:"Mi  cuenta",
                }
                var serv04= {
                    active:true,
                    code:"serv04",
                    name:"Mis direcciones",
                }
                var serv05= {
                    active:true,
                    code:"serv05",
                    name:"My Maps",
                }
                var serv06= {
                    active:true,
                    code:"serv06",
                    name:"Send Bugs",
                }
                var serv07= {
                    active:true,
                    code:"serv07",
                    name:"Send Message",
                }
                var serv08= {
                    active:true,
                    code:"serv08",
                    name:"Suport Ticket",
                }
                var serv09= {
                    active:true,
                    code:"serv09",
                    name:"Manager Companies",
                }
                var serv10= {
                    active:true,
                    code:"serv10",
                    name:"Manager Stores",
                }
                var serv11= {
                    active:true,
                    code:"serv11",
                    name:"Manager Usuarios",
                }
                var serv12= {
                    active:true,
                    code:"serv12",
                    name:"Manager Admins",
                }
                var serv13= {
                    active:true,
                    code:"serv13",
                    name:"manager Users",
                }
                var serv14= {
                    active:true,
                    code:"serv14",
                    name:"Crear despachos",
                }
                var serv15= {
                    active:true,
                    code:"serv15",
                    name:"manager dispatch",
                }
                var serv16= {
                    active:true,
                    code:"serv16",
                    name:"manager drivers",
                }
                var serv17= {
                    active:true,
                    code:"serv17",
                    name:"manager guides",
                }
                var serv18= {
                    active:true,
                    code:"serv18",
                    name:"manager routes",
                }
                var serv19= {
                    active:true,
                    code:"serv19",
                    name:"manager_maps monitor",
                }
                var serv20= {
                    active:true,
                    code:"serv20",
                    name:"manager services",
                }
                var serv21= {
                    active:true,
                    code:"serv21",
                    name:"manager settings",
                }
                var serv22= {
                    active:true,
                    code:"serv22",
                    name:"manager segurity",
                }
                var serv23= {
                    active:true,
                    code:"serv23",
                    name:"manager bugs",
                }
                var serv24= {
                    active:true,
                    code:"serv24",
                    name:"manager msj",
                }
                var serv25= {
                    active:true,
                    code:"serv25",
                    name:"manager soporte",
                }    
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("develop").set(develop);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv01").set(serv01);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv02").set(serv02);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv03").set(serv03);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv04").set(serv04);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv05").set(serv05);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv06").set(serv06);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv07").set(serv07);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv08").set(serv08);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv09").set(serv09);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv10").set(serv10);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv11").set(serv11);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv12").set(serv12);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv13").set(serv13);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv14").set(serv14);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv15").set(serv15);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv16").set(serv16);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv17").set(serv17);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv18").set(serv18);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv19").set(serv19);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv20").set(serv20);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv21").set(serv21);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv22").set(serv22);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv23").set(serv23);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv24").set(serv24);
                await db.collection(`${process.env.REACT_APP_COL_CODESERVICES}`).doc("serv25").set(serv25);
                console.log("Collecion Code Services creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'coments'){
            try {
               var model6 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_COMENTS}`).doc().set(model6);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'companies'){
            try {
               var model7 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_COMPANIES}`).doc().set(model7);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'contactsGlobal'){
            try {
               var model8 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_CONTACTS}`).doc().set(model8);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'orders'){
            try {
               var model9 = {
                   variable : "valor",
                   variable2 : "valor2",
                   }        
               await db.collection(`${process.env.REACT_APP_COL_ORDERS}`).doc().set(model9);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'paymentmethods'){
            try {
               var model10 = {
                descripcion:"Paga desde tu banco con transferencia, registra tu pago con el id de la transacción.",
                id:"001",
                docId:'directTransfer',
                name:"Transferencia",
                uid:'sistema',
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                TimeStamp:Date.now(),		
                }     
                var model101 = {
                 descripcion:"La mejor plataforma para cobrar, pagar y tener tu dinero protegido.",
                 id:"002",
                 docId:'mercadopago',
                 name:"Mercado Pago",
                 uid:'sistema',
                 createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                 TimeStamp:Date.now(),		
                }     
                             
               await db.collection(`${process.env.REACT_APP_COL_PAYMETHODS}`).doc('directTransfer').set(model10);
               await db.collection(`${process.env.REACT_APP_COL_PAYMETHODS}`).doc('mercadopago').set(model101);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'paymentoptions'){
            try {
               var model113 = {
                id:"001",
                name:"Prepago",
                docId:'prepago',
                uid:'sistema',
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                TimeStamp:Date.now(),	
                   }   
                var model123 = {
                id:"002",
                name:"Pospago",
                docId:'Pospago',
                uid:'sistema',
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                TimeStamp:Date.now(),	
                } 
                var model133 = {
                id:"003",
                name:"suscripcion",
                docId:'suscripcion',
                uid:'sistema',
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                TimeStamp:Date.now(),	
                }      
               await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`).doc('prepago').set(model113);
               await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`).doc('pospago').set(model123);
               await db.collection(`${process.env.REACT_APP_COL_PAYOPTIONS}`).doc('suscripcion').set(model133);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'products'){
            try {
               var model12 = {
                articleType:'packServicExpress',  // tipo de articulo pack de Servico Express  ARTYPE
                ServicExpressType:'bagServicExpress', //  servicExpress => bolsa bagServicExpress  -o- plan planServicExpress, 
                rateService: 'PLAN1',
                articlePrice: 45000,
                discount: 0,
                discountType: '',
                subTotal: 45000,
                total: 45000,
                createBy:"l73Dv9T1q6c1TaBvmi4xPDem4e22",
                createDate:"20 June 2022, 8:34:08 pm",
                date:1655771648619,
                description:"15 envíos acumulables",
                descriptorsWEB0:"Next Day Delivery",
                descriptorsWEB1:" Same Day Delivery",
                descriptorsWEB10:"",
                descriptorsWEB2:"Logistica Reversa",
                descriptorsWEB3:"15 envíos con un precio especial",
                descriptorsWEB4:"",
                descriptorsWEB5:"",
                descriptorsWEB6:"",
                descriptorsWEB7:"",
                descriptorsWEB8:"",
                descriptorsWEB9:"",
                isActive:true,
                isDelete:false,
                inPublic:false,
                productId:"PRODUCTID1",
                id:"PRODUCTID1",
                productName:"Pack 15 envíos",
                slug:"pack-15-envios",
                ChargeShipments:15
                   }        
               await db.collection(`${process.env.REACT_APP_COL_PRODUCTS}`).doc('PRODUCTID1').set(model12);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'purchasesummaries'){
            try {
               var model13 = {
                   variable : "valor",
                   variable2 : "valor2",
                   buyOrder: '1',
                   companyUid : "companyUid",
                   isParcial : false,
                   payMethod : 'directTransfer',
                   pendingPayment: 0,
                   cartArticleItem: 'dumyCar',
                   tranzascionID: 1,
                   CodeTransfer: '',
                   urlTransferEvidence: '',
                   webpay_rest_response: '',
                   webpay_transaction_id: '',
                   transactionResponse: '',
                   transactionDate: '',
                   authorizationCode: '',
                   purchaseState: 1,
                   BillingClientCompany: 'BillingClientCompany', 
                   BillingClientName: 'BillingClientName',
                   BillingClientLastName: 'BillingClientLastName',
                   BillingDir1: 'BillingDir1',
                   BillingDir2: 'BillingDir2',
                   BillingDir3: 'BillingDir3',
                   BillingCity: 'BillingCity',
                   BillingZip: 'BillingZip',
                   BillingCountry: 'BillingCountry',
                   BillingRegion: 'BillingRegion',
                   BillingEmail: 'BillingEmail@email.com',
                   BillingPhone: 'BillingPhone',
                   subtotal: 45000,
                   totalShipping: 0,
                   discount: 0,
                   discountType: '',
                   TotalOrder: 45000,
                   paidAmount: 45000,
                   shippimgClientName:'shippimgClientName' ,
                   shippimgClientLastName:'shippimgClientLastName',
                   shippimgClientCompany: 'shippimgClientCompany',
                   shippimgDir1: 'shippimgDir1',
                   shippimgDir2: 'shippimgDir2',
                   shippimgDir3: 'shippimgDir3',
                   shippimgCity: 'shippimgCity',
                   shippimgZip: 'shippimgZip',
                   shippimgCountry: 'shippimgCountry',
                   shippimgRegion: 'shippimgRegion',
                   shippimgEmail: 'shippimgEmail',
                   shippimgPhone: 'shippimgPhone',
                   shippingNotes: 'shippingNotes',
                   }        
               await db.collection(`${process.env.REACT_APP_COL_SUMARIES}`).doc('dumyPurchasesummaries').set(model13);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'car'){
            try {
               var model141 = {
                   uid:'usuario',
                   createAdd:'11 Jun 2022 08:36:27',
                   TimeStamp: '1654950987',	
                   "1":{
                    cartArticleId:'PRODUCTID11',
                    articleType:'packServicExpress',  // tipo de articulo pack de Servico Express  ARTYPE
                    ServicExpressType:'bagServicExpress', //  servicExpress => bolsa bagServicExpress  -o- plan planServicExpress, 
                    rateService: 'PLAN1',
                    productName: 'Pack 15 envíos',
                    cartArticlePrice: 45000,
                    cartArticlCuality: 1,
                    subTotalItem: 45000,
                    shippimgMethod: '',
                    shippimgAmount: 0,
                    ShippingAddress: '',
                    discount: 0,
                    discountType: '',
                   }
                   }        
               await db.collection(`${process.env.REACT_APP_COL_CARS}`).doc('dumyCar').set(model141);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'rates'){
            try {
               var model14 = {
                ratetId : "pack_15_envíos",
                rateName: "Dumy Pack 15 envíos",
                uid:'sistema',
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                TimeStamp:Date.now(),	
                isActive:true,
                isPublic:true,
                t001holidaydelivery3000:3000,
                t001outoftime3000:3000,
                t001radioof3000:3000,
                t001pack10x203000:3000,
                t001pack20x203000:3000,
                t001pack30x303000:3000,
                t001pack40x403000:3000,
                t002holidaydelivery3000:3000,
                t002outoftime3000:3000,
                t002radioof3000	:3000,
                t002pack10x203000:3000,
                t002pack20x203000:3000,
                t002pack30x303000:3000,
                t002pack40x403000:3000,
                t003holidaydelivery3000:3000,
                t003outoftime3000:3000,
                t003radioof3000:3000,
                t003pack10x203000:3000,
                t003pack20x203000:3000,
                t003pack30x303000:3000,
                t003pack40x403000:3000,
                t004holidaydelivery3000:3000,
                t004outoftime3000:3000,
                t004radioof3000:3000,
                t004pack10x203000:3000,
                t004pack20x203000:3000,
                t004pack30x303000:3000,
                t004pack40x403000:3000,
                   }        
               await db.collection(`${process.env.REACT_APP_COL_RATES}`).doc('dumy_pack_15_envíos').set(model14);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'roles'){
                
            //client
            try {
                     //client Admin

                     var clientAdmin = {
                        serv01 : true,
                        serv02 : true,
                        serv03: true,
                        serv04: true,
                        serv05: true,
                        serv06: true,
                        serv07: true,
                        serv08: true,
                        serv09: true,
                        serv10: false,
                        serv11: false,
                        serv12: false,
                        serv13: false,
                        serv14: false,
                        serv15: true,
                        serv16: false,
                        serv17: false,
                        serv18: false,
                        serv19: false,
                        serv20: true,
                        serv21: false,
                        serv22: false,
                        serv23: false,
                        serv24: false,
                        serv25: false,
                           } 
          
                //client operador

                var operador = {
                   serv01 : true,
                   serv02 : true,
                   serv03: true,
                   serv04: true,
                   serv05: true,
                   serv06: true,
                   serv07: true,
                   serv08: true,
                   serv09: true,
                   serv10: false,
                   serv11: false,
                   serv12: false,
                   serv13: false,
                   serv14: false,
                   serv15: true,
                   serv16: false,
                   serv17: false,
                   serv18: false,
                   serv19: false,
                   serv20: true,
                   serv21: false,
                   serv22: false,
                   serv23: false,
                   serv24: false,
                   serv25: false,
                      } 
               var model15 = {
                serv01 : true,
                serv02 : true,
                serv03: true,
                serv04: true,
                serv05: true,
                serv06: true,
                serv07: true,
                serv08: true,
                serv09: true,
                serv10: false,
                serv11: false,
                serv12: false,
                serv13: false,
                serv14: false,
                serv15: true,
                serv16: false,
                serv17: false,
                serv18: false,
                serv19: false,
                serv20: true,
                serv21: false,
                serv22: false,
                serv23: false,
                serv24: false,
                serv25: false,
                   } 
                //biccicpressAdmin       
                var model151 = {
                    serv01 : true,
                    serv02 : true,
                    serv03: true,
                    serv04: true,
                    serv05: true,
                    serv06: true,
                    serv07: true,
                    serv08: true,
                    serv09: true,
                    serv10: true,
                    serv11: true,
                    serv12: true,
                    serv13: true,
                    serv14: true,
                    serv15: true,
                    serv16: true,
                    serv17: true,
                    serv18: true,
                    serv19: true,
                    serv20: true,
                    serv21: true,
                    serv22: true,
                    serv23: true,
                    serv24: true,
                    serv25: true,
                       } 
                await db.collection(`${process.env.REACT_APP_COL_ROLES}`).doc('client').set(model15);
                await db.collection(`${process.env.REACT_APP_COL_ROLES}`).doc('biccixpressAdmin').set(model151);
                await db.collection(`${process.env.REACT_APP_COL_ROLES}`).doc('company_admin').set(clientAdmin);
                await db.collection(`${process.env.REACT_APP_COL_ROLES}`).doc('company_ops').set(operador);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'shippingWalletBalance'){
            try {
               var model16 = {
                   companyUid : "companyUid",	
                   isActiveWallet: true,	
                   balance	: 5,
                   MaxCredit: 5	,
                   maxCoverage: 2,	
                   lastRecharge:  '11 Jun 2022 08:36:27',
                   TimeStamp: '1654950987',	
                   shippingQuotas: 5,	
                   pendingPayment: 0,	
                   }        
               await db.collection(`${process.env.REACT_APP_COL_BALANCE}`).doc('companyUid').set(model16);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'CompanybillingAccount'){
            try {
                const accountants =  await db.collection(`${process.env.REACT_APP_COL_AVIABLE_SERV}`)
                .get();
                var dataResult = accountants.docs.map(doc => ({id: doc.id, ...doc.data()}))
            
               var model17 = {
                    companyUid: 'companyUid',
                    payOptions: 'prepago',
                    isActiveBilling: true,
                    MaxCredit: 5,
                    maxCoverage: 5, // cal
                    lastRecharge:  '11 Jun 2022 08:36:27',
                    TimeStamp: '1654950987',	
                    shippingQuotas: 5, // cal
                    pendingPayment: 0, // cal
                    payMethod : 'directTransfer',
                    companyName: 'companyName',
                    companyRut: '111111111-1',
                    companyPropietary: 'userID',
                    accountExecutive: 'userID',
                    shipmentsAvailable: 5, // cal
                    suspensionDays: 5,
                    dayBilling: 1,
                    expirationDate: 6,
                    giftDays: 5,
                    nextSuspensionDate: 'nextSuspensionDate', // cal
                    t001holidaydelivery3000:true,
                    t001outoftime3000:true,
                    t001radioof3000:true,
                    t001pack10x203000:true,
                    t001pack20x203000:true,
                    t001pack30x303000:true,
                    t001pack40x403000:true,
                    t002holidaydelivery3000:true,
                    t002outoftime3000:true,
                    t002radioof3000:true,
                    t002pack10x203000:true,
                    t002pack20x203000:true,
                    t002pack30x303000:true,
                    t002pack40x403000:true,
                    t003holidaydelivery3000:true,
                    t003outoftime3000:true,
                    t003radioof3000:true,
                    t003pack10x203000:true,
                    t003pack20x203000:true,
                    t003pack30x303000:true,
                    t003pack40x403000:true,
                    t004holidaydelivery3000:true,
                    t004outoftime3000:true,
                    t004radioof3000:true,
                    t004pack10x203000:true,
                    t004pack20x203000:true,
                    t004pack30x303000:true,
                    t004pack40x403000:true,
                    availableservices:dataResult,
                   }        
               await db.collection(`${process.env.REACT_APP_COL_BILLING}`).doc('dumyCompanybillingAccount').set(model17);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'historyCompanybillingAccount'){
            try {
               var model171 = {
                buyOrder: '1',
                cardNumber:'dumyCar',
                amount:45000, // TotalOrder
                payAmount:45000,
                pendingPayment: 0, // Pago parcial o completo
                transactionDate: '', // Intentoss de pago - 
                payMethod : 'directTransfer',
                tranzascionID: 1,
                numberSiiBilling:'', ////transactionResponse
                urlPdfSiiBilling:'', //transactionResponse
                CodeTransfer: '', //transactionResponse
                urlTransferEvidence: '', //transactionResponse
                status:'pending'
                }  
                  
                   
               await db.collection(`${process.env.REACT_APP_COL_BILLING}`)
               .doc('dumyCompanybillingAccount')
               .collection('history')
               .doc('model171').set(model171);

               // console.log("Collecion Historial creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'GlobalsBillings'){
            try {
               var model18 = {
                    tranzascionID:1,
                    haveDoc:true,
                    urlDocs:'',
                    dayBilling:1,
                    expirationDate:6,
                    giftDays:5,
                    suspensionDate: 'nextSuspensionDate', // cal
                    CodeTransfer:'',
                    urlTransferEvidence:'',
                    companyUid:'companyUid',
                    payOptionsSelect:'prepago', //payOptions
                    isActiveBilling:true,
                    MaxCredit:5,
                    maxCoverage:2,
                    lastRecharge:'11 Jun 2022 08:36:27',
                    pendingPayment:0,
                    payMethod:'directTransfer',
                    amount:45000,
                    buyOrder:1,
                    cardNumber:'dumyCar',
                    transactionDate:'',
                    balance:'',
                    companyName:5,
                    companyRut:'111111111-1',
                    companyPropietary:'userID',
                    balloonPayment:0,//cal
                    globalShippings:0,//cal
                    totalTransactions:0,//call
                    urlPdfSiiBilling:'', //transactionResponse
                    numberSiiBilling:'', ////transactionResponse
                    t001holidaydelivery3000:true,
                    t001outoftime3000:true,
                    t001radioof3000:true,
                    t001pack10x203000:true,
                    t001pack20x203000:true,
                    t001pack30x303000:true,
                    t001pack40x403000:true,
                    t002holidaydelivery3000:true,
                    t002outoftime3000:true,
                    t002radioof3000:true,
                    t002pack10x203000:true,
                    t002pack20x203000:true,
                    t002pack30x303000:true,
                    t002pack40x403000:true,
                    t003holidaydelivery3000:true,
                    t003outoftime3000:true,
                    t003radioof3000:true,
                    t003pack10x203000:true,
                    t003pack20x203000:true,
                    t003pack30x303000:true,
                    t003pack40x403000:true,
                    t004holidaydelivery3000:true,
                    t004outoftime3000:true,
                    t004radioof3000:true,
                    t004pack10x203000:true,
                    t004pack20x203000:true,
                    t004pack30x303000:true,
                    t004pack40x403000:true,

                   }        
               await db.collection(`${process.env.REACT_APP_COL_GLOBALBILLING}`).doc('1').set(model18);
               // console.log("Collecion creada");
                  } catch (error) {
                 // console.log(error);
               }
        }
        if(accion === 'typesPackes'){

            try {
            var HoliDayDelivery001 = {
                createBy:"system",
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                date:Date.now(),
                description:"Feriados Despacho punto a punto",
                imagenes:"",
                isActive:true,
                name:"Feriados Despacho punto a punto",
                packageHeight:40,
                packageLength:40,
                packageMaxWeight:15,
                packageMinWeight:0.1,
                packageWidth:40,
                position:0,
                productId:"001HoliDayDelivery",
                xpressAvailableservices:"001",
                }       
            var OutOfTime001 = {
                createBy:"system",
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                date:Date.now(),
                description:"Fuera de horarios Despacho punto a punto",
                imagenes:"",
                isActive:true,
                name:"Fuera de horarios Despacho punto a punto",
                packageHeight:40,
                packageLength:40,
                packageWidth:40,
                packageMaxWeight:15,
                packageMinWeight:0.1,
                position:0,
                productId:"001OutOfTime",
                xpressAvailableservices:"001",
                }    
            var RadioOff001 = {
                  createBy:"system",
                  createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                  date:Date.now(),
                  description:"Fuera de Radio punto a punto ",
                  imagenes:"",
                  isActive:true,
                  name:"Fuera de Radio punto a punto ",
                  packageHeight:40,
                  packageLength:40,
                  packageWidth:40,
                  packageMaxWeight:15,
                  packageMinWeight:0.1,
                  position:0,
                  productId:"001RadioOff001",
                  xpressAvailableservices:"001",
                }   
            var pack10x20100 = {
                 createBy:"system",
                 createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                 date:Date.now(),
                 description:"Sobre despacho punto a punto",
                 imagenes:"",
                 isActive:true,
                 name:"Sobre despacho punto a punto",
                 packageHeight:20,
                 packageLength:10,
                 packageWidth:5,
                 packageMaxWeight:5,
                 packageMinWeight:0.1,
                 position:0,
                 productId:"001pack10x20",
                 xpressAvailableservices:"001",
                } 
            var pack20x20100 = {
                 createBy:"system",
                 createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                 date:Date.now(),
                 description:"Paquete despacho punto a punto",
                 imagenes:"",
                 isActive:true,
                 name:"Paquete despacho punto a punto",
                 packageHeight:20,
                 packageLength:20,
                 packageWidth:20,
                 packageMaxWeight:1,
                 packageMinWeight:0.5,
                 position:0,
                 productId:"001pack10x20",
                xpressAvailableservices:"001",
                } 
            var pack30x30100 = {
                createBy:"system",
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                date:Date.now(),
                description:"Paquete despacho punto a punto",
                imagenes:"",
                isActive:true,
                name:"Paquete despacho punto a punto",
                packageHeight:30,
                packageLength:30,
                packageWidth:30,
                packageMaxWeight:5,
                packageMinWeight:1.1,
                position:0,
                productId:"001pack10x20",
                xpressAvailableservices:"001",
                }
            var pack40x40100 = {
                createBy:"system",
                createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                date:Date.now(),
                description:"Paquete despacho punto a punto",
                imagenes:"",
                isActive:true,
                name:"Paquete despacho punto a punto",
                packageHeight:40,
                packageLength:40,
                packageWidth:40,
                packageMaxWeight:15,
                packageMinWeight:5.1,
                position:0,
                productId:"001pack40x40",
                xpressAvailableservices:"001",
                }  
            var HoliDayDelivery002 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Feriados Next Day Delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Feriados Next Day Delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageMaxWeight:15,
                    packageMinWeight:0.1,
                    packageWidth:40,
                    position:0,
                    productId:"002HoliDayDelivery",
                    xpressAvailableservices:"002",
                }       
            var OutOfTime002 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Fuera de horarios Next Day Delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Fuera de horarios Next Day Delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageWidth:40,
                    packageMaxWeight:15,
                    packageMinWeight:0.1,
                    position:0,
                    productId:"002OutOfTime",
                    xpressAvailableservices:"002",
                }    
            var RadioOff002 = {
                      createBy:"system",
                      createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                      date:Date.now(),
                      description:"Fuera de Radio Next Day Delivery",
                      imagenes:"",
                      isActive:true,
                      name:"Fuera de Radio Next Day Delivery",
                      packageHeight:40,
                      packageLength:40,
                      packageWidth:40,
                      packageMaxWeight:15,
                      packageMinWeight:0.1,
                      position:0,
                      productId:"002RadioOff002",
                      xpressAvailableservices:"002",
                }   
            var pack10x20200 = {
                     createBy:"system",
                     createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                     date:Date.now(),
                     description:"Sobre despacho Next Day Delivery",
                     imagenes:"",
                     isActive:true,
                     name:"Sobre despacho Next Day Delivery",
                     packageHeight:20,
                     packageLength:10,
                     packageWidth:5,
                     packageMaxWeight:5,
                     packageMinWeight:0.1,
                     position:0,
                     productId:"002pack10x20",
                     xpressAvailableservices:"002",
                } 
            var pack20x20200 = {
                     createBy:"system",
                     createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                     date:Date.now(),
                     description:"Paquete despacho Next Day Delivery",
                     imagenes:"",
                     isActive:true,
                     name:"Paquete despacho Next Day Delivery",
                     packageHeight:20,
                     packageLength:20,
                     packageWidth:20,
                     packageMaxWeight:1,
                     packageMinWeight:0.5,
                     position:0,
                     productId:"002pack10x20",
                    xpressAvailableservices:"002",
                } 
            var pack30x30200 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Paquete despacho Next Day Delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Paquete despacho Next Day Delivery",
                    packageHeight:30,
                    packageLength:30,
                    packageWidth:30,
                    packageMaxWeight:5,
                    packageMinWeight:1.1,
                    position:0,
                    productId:"002pack10x20",
                    xpressAvailableservices:"002",
                }
            var pack40x40200 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Paquete despacho Next Day Delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Paquete despacho Next Day Delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageWidth:40,
                    packageMaxWeight:15,
                    packageMinWeight:5.1,
                    position:0,
                    productId:"002pack40x40",
                    xpressAvailableservices:"002",
                }  
            var HoliDayDelivery003 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Feriados Same day delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Feriados Same day delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageMaxWeight:15,
                    packageMinWeight:0.1,
                    packageWidth:40,
                    position:0,
                    productId:"003HoliDayDelivery",
                    xpressAvailableservices:"003",
                }       
            var OutOfTime003 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Fuera de horarios Same day delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Fuera de horarios Same day delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageWidth:40,
                    packageMaxWeight:15,
                    packageMinWeight:0.1,
                    position:0,
                    productId:"003OutOfTime",
                    xpressAvailableservices:"003",
                }    
            var RadioOff003 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Fuera de Radio Same day delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Fuera de Radio Same day delivery",
                    packageHeight:40,
                    packageLength:40,
                    packageWidth:40,
                    packageMaxWeight:15,
                    packageMinWeight:0.1,
                    position:0,
                    productId:"003RadioOff003",
                    xpressAvailableservices:"003",
                }   
            var pack10x20300 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Sobre despacho Same day delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Sobre despacho Same day delivery",
                    packageHeight:20,
                    packageLength:10,
                    packageWidth:5,
                    packageMaxWeight:5,
                    packageMinWeight:0.1,
                    position:0,
                    productId:"003pack10x20",
                    xpressAvailableservices:"003",
                } 
            var pack20x20300 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    description:"Paquete despacho Same day delivery",
                    imagenes:"",
                    isActive:true,
                    name:"Paquete despacho Same day delivery",
                    packageHeight:20,
                    packageLength:20,
                    packageWidth:20,
                    packageMaxWeight:1,
                    packageMinWeight:0.5,
                    position:0,
                    productId:"003pack10x20",
                    xpressAvailableservices:"003",
                } 
            var pack30x30300 = {
                        createBy:"system",
                        createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                        date:Date.now(),
                        description:"Paquete despacho Same day delivery",
                        imagenes:"",
                        isActive:true,
                        name:"Paquete despacho Same day delivery",
                        packageHeight:30,
                        packageLength:30,
                        packageWidth:30,
                        packageMaxWeight:5,
                        packageMinWeight:1.1,
                        position:0,
                        productId:"003pack10x20",
                        xpressAvailableservices:"003",
                }
            var pack40x40300 = {
                        createBy:"system",
                        createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                        date:Date.now(),
                        description:"Paquete despacho Same day delivery",
                        imagenes:"",
                        isActive:true,
                        name:"Paquete despacho Same day delivery",
                        packageHeight:40,
                        packageLength:40,
                        packageWidth:40,
                        packageMaxWeight:15,
                        packageMinWeight:5.1,
                        position:0,
                        productId:"003pack40x40",
                        xpressAvailableservices:"003",
                } 
            var HoliDayDelivery004 = {
                            createBy:"system",
                            createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                            date:Date.now(),
                            description:"Feriados Logística Reversa",
                            imagenes:"",
                            isActive:true,
                            name:"Feriados Logística Reversa",
                            packageHeight:40,
                            packageLength:40,
                            packageMaxWeight:15,
                            packageMinWeight:0.1,
                            packageWidth:40,
                            position:0,
                            productId:"004HoliDayDelivery",
                            xpressAvailableservices:"004",
                }       
            var OutOfTime004 = {
                            createBy:"system",
                            createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                            date:Date.now(),
                            description:"Fuera de horarios Logística Reversa",
                            imagenes:"",
                            isActive:true,
                            name:"Fuera de horarios Logística Reversa",
                            packageHeight:40,
                            packageLength:40,
                            packageWidth:40,
                            packageMaxWeight:15,
                            packageMinWeight:0.1,
                            position:0,
                            productId:"004OutOfTime",
                            xpressAvailableservices:"004",
                }    
            var RadioOff004 = {
                              createBy:"system",
                              createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                              date:Date.now(),
                              description:"Fuera de Radio Logística Reversa",
                              imagenes:"",
                              isActive:true,
                              name:"Fuera de Radio Logística Reversa",
                              packageHeight:40,
                              packageLength:40,
                              packageWidth:40,
                              packageMaxWeight:15,
                              packageMinWeight:0.1,
                              position:0,
                              productId:"004RadioOff004",
                              xpressAvailableservices:"004",
                }   
            var pack10x20400 = {
                             createBy:"system",
                             createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                             date:Date.now(),
                             description:"Sobre despacho Logística Reversa",
                             imagenes:"",
                             isActive:true,
                             name:"Sobre despacho Logística Reversa",
                             packageHeight:20,
                             packageLength:10,
                             packageWidth:5,
                             packageMaxWeight:5,
                             packageMinWeight:0.1,
                             position:0,
                             productId:"004pack10x20",
                             xpressAvailableservices:"004",
                } 
            var pack20x20400 = {
                             createBy:"system",
                             createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                             date:Date.now(),
                             description:"Paquete despacho Logística Reversa",
                             imagenes:"",
                             isActive:true,
                             name:"Paquete despacho Logística Reversa",
                             packageHeight:20,
                             packageLength:20,
                             packageWidth:20,
                             packageMaxWeight:1,
                             packageMinWeight:0.5,
                             position:0,
                             productId:"004pack10x20",
                            xpressAvailableservices:"004",
                } 
            var pack30x30400 = {
                            createBy:"system",
                            createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                            date:Date.now(),
                            description:"Paquete despacho Logística Reversa",
                            imagenes:"",
                            isActive:true,
                            name:"Paquete despacho Logística Reversa",
                            packageHeight:30,
                            packageLength:30,
                            packageWidth:30,
                            packageMaxWeight:5,
                            packageMinWeight:1.1,
                            position:0,
                            productId:"004pack10x20",
                            xpressAvailableservices:"004",
                }
            var pack40x40400 = {
                            createBy:"system",
                            createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                            date:Date.now(),
                            description:"Paquete despacho Logística Reversa",
                            imagenes:"",
                            isActive:true,
                            name:"Paquete despacho Logística Reversa",
                            packageHeight:40,
                            packageLength:40,
                            packageWidth:40,
                            packageMaxWeight:15,
                            packageMinWeight:5.1,
                            position:0,
                            productId:"004pack40x40",
                            xpressAvailableservices:"004",
                } 
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001HoliDayDelivery').set(HoliDayDelivery001);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001OutOfTime').set(OutOfTime001);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001RadioOF').set(RadioOff001);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001pack10x20').set(pack10x20100);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001pack20x20').set(pack20x20100);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001pack30x30').set(pack30x30100);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('001pack40x40').set(pack40x40100);

                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002HoliDayDelivery').set(HoliDayDelivery002);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002OutOfTime').set(OutOfTime002);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002RadioOF').set(RadioOff002);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002pack10x20').set(pack10x20200);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002pack20x20').set(pack20x20200);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002pack30x30').set(pack30x30200);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('002pack40x40').set(pack40x40200);

                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003HoliDayDelivery').set(HoliDayDelivery003);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003OutOfTime').set(OutOfTime003);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003RadioOF').set(RadioOff003);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003pack10x20').set(pack10x20300);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003pack20x20').set(pack20x20300);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003pack30x30').set(pack30x30300);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('003pack40x40').set(pack40x40300);

                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004HoliDayDelivery').set(HoliDayDelivery004);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004OutOfTime').set(OutOfTime004);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004RadioOF').set(RadioOff004);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004pack10x20').set(pack10x20400);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004pack20x20').set(pack20x20400);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004pack30x30').set(pack30x30400);
                await db.collection(`${process.env.REACT_APP_COL_TYPEPACKS}`).doc('004pack40x40' ).set(pack40x40400);
               // console.log("Colleciones tipos de paquetes creada");
                  } catch (error) {
                 // console.log(error);
               }
        }

        if(accion === 'VehiclesTypes'){
            try {
               var Caminando = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    name:"Bicicleta",
                    description:"Entrega caminando por una persona",
                    id:"WALKING",
                    travelMode:"WALKING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                    } 
               var bicicleta = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    name:"Bicicleta",
                    description:"Vehículo de dos ruedas movido por una persona",
                    id:"BICYCLING",
                    travelMode:"BICYCLING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                } 
                var vehiculo = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    name:"Bicicleta",
                    description:"Entrega en vehículo por una persona o mas personas",
                    id:"DRIVING",
                    travelMode:"DRIVING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                 } 
                 var Motorizado = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    name:"Bicicleta",
                    description:"Entrega en vehículo motorizado",
                    id:"TWO_WHEELER",
                    travelMode:"TWO_WHEELER",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                 } 
                 var ecobicicleta = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    name:"Eco Bicci",
                    description:"Vehículo eléctrico de dos ruedas",
                    id:"DRIVING",
                    travelMode:"DRIVING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                } 
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`).doc('BICYCLING').set(bicicleta);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`).doc('WALKING').set(Caminando);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`).doc('DRIVING').set(vehiculo);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`).doc('TWO_WHEELER').set(Motorizado);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES_TYPES}`).doc('ECOBICCI').set(ecobicicleta);

               // console.log("Colleciones tipos de vehículos creada");
                  } catch (error) {
                 // console.log(error);
               }
        }

        if(accion === 'xpresssVehicles'){
            try {
                 var vehiculodumy = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    id:"ECOBICCIDUMY",
                    VehiclesTypes:"ECOBICCI",
                    travelMode:"BICYCLING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                    cluster:"",
                    origen : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    destiny : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    workingDayMinHour:8,
                    workingDayMaxHour:20,
                } 
                var vehiculodumy2 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    id:"ECOBICCIDUMY2",
                    VehiclesTypes:"TWO_WHEELER",
                    travelMode:"TWO_WHEELER",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                    cluster:"",
                    origen : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    destiny : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    workingDayMinHour:8,
                    workingDayMaxHour:20,
                }
                var vehiculodumy3 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    id:"ECOBICCIDUMY3",
                    VehiclesTypes:"WALKING",
                    travelMode:"WALKING",
                    maxSpeed:"",
                    maxTransportCapacityVol:"",
                    minTransportCapacityVol:"",
                    maximumCoverage:"",
                    packetCapacity:"",
                    requireMinPacketCapacity:"",
                    cluster:"",
                    origen : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    destiny : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    workingDayMinHour:8,
                    workingDayMaxHour:20,
                }
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES}`).doc('ECOBICCIDUMY').set(vehiculodumy);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES}`).doc('ECOBICCIDUMY2').set(vehiculodumy2);
                await db.collection(`${process.env.REACT_APP_COL_VEHICLES}`).doc('ECOBICCIDUMY3').set(vehiculodumy3);

               // console.log("Colleciones tipos de vehículos creada");
                  } catch (error) {
                 // console.log(error);
               }
        }

        if(accion === 'xpresssDriverRoutes'){
            try {
                var xpresssDriverRoutes1 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    id:"routedumy3",
                    vehicleID:"ECOBICCIDUMY",
                    driverID:"LVY9zIL1OAbep6OvrrjEovLsKRD2",
                    driverName:"Adrian Medina",
                    travelMode:"BICYCLING",
                    companyId:"11111111-8",
                    currentOrderList:{ // Array relacional a wayPoints crear ruta en base a geopuntos de currentOrderList
                        0:"190593645",
                        1:"191613647"
                    },
                  
                    origin : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    destination : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    optimizeWaypoints:true,  // si el falso se debe reodenar wayPoints segun las prioridades manualmente
                    wayPoints: [
                        {
                          location: { lat: -33.41440257217985, lng: -70.59752492426757}, 
                          stopover: true,
                        },
                        {
                          location: { lat: -33.41936375583752, lng: -70.59555081843261}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.41404435300238, lng: -70.60082940577392}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.41800259286872, lng: -70.59224633692627}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.418217514756016, lng: -70.58877019404297}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.415477220846874, lng: -70.59426335810547},
                          stopover: true,
                        },
                        {
                          location: { lat:-33.418217514756016, lng: -70.58877019404297}, 
                          stopover: true,
                        },
                        {
                            location: { lat:-33.42500519064097, lng: -70.59737472056274}, 
                            stopover: true,
                        },
                        {
                            location: { lat:-33.42267702387671, lng: -70.60273913859253}, 
                            stopover: true,
                        },
                        {
                          location: { lat:-33.421208455806195, lng: -70.58789042948608}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.42342920765859, lng: -70.59153823374633}, 
                          stopover: true,
                        },
                    
                      ],
                    maxTimeDelivery:15,
                    dateDeliveryText:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    dateDelivery:Date.now(),
                    startTimeDelivery:15,
                    endTimeDelivery:15,
                    waypoint_order:[
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ],
                    distanceValue:0,
                    durationValue:0,
                    setRoutePoints:0,
                    dispacthDelyvery:0,
                    dispacthPartials:0,
                    dispacthNotDelyvery:0,
                    fullCompliance:0,
                    warnings:"",
                    isDelete: false,
                    isActive:true,
                } 
                var xpresssDriverRoutes2 = {
                    createBy:"system",
                    createDate:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    date:Date.now(),
                    id:"routedumy4",
                    vehicleID:"ECOBICCIDUMY",
                    driverID:"LVY9zIL1OAbep6OvrrjEovLsKRD2",
                    driverName:"Adrian Medina",
                    companyId:"26456608-8",
                    travelMode:"BICYCLING",
                    currentOrderList:{ //  Array relacional a wayPoints crear ruta en base a geopuntos de currentOrderList
                        0:"190593645",
                        1:"191613647"
                    },
                    origin : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    destination : { lat: -33.41856676168833 , lng: -70.6027176809204},
                    optimizeWaypoints:false,  // si el falso se debe reodenar wayPoints segun las prioridades manualmente
                    wayPoints: [
                        {
                          location: { lat: -33.41440257217985, lng: -70.59752492426757}, 
                          stopover: true,
                        },
                        {
                          location: { lat: -33.41936375583752, lng: -70.59555081843261}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.41404435300238, lng: -70.60082940577392}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.415477220846874, lng: -70.59426335810547},
                          stopover: true,
                        },
                        {
                          location: { lat:-33.41800259286872, lng: -70.59224633692627}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.418217514756016, lng: -70.58877019404297}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.418217514756016, lng: -70.58877019404297}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.421208455806195, lng: -70.58789042948608}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.42342920765859, lng: -70.59153823374633}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.42500519064097, lng: -70.59737472056274}, 
                          stopover: true,
                        },
                        {
                          location: { lat:-33.42267702387671, lng: -70.60273913859253}, 
                          stopover: true,
                        },
                    
                      ],
                    maxTimeDelivery:15,
                    dateDeliveryText:moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
                    dateDelivery:Date.now(),
                    startTimeDelivery:15,
                    endTimeDelivery:15,
                    waypoint_order:[
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ],
                    distanceValue:0,
                    durationValue:0,
                    setRoutePoints:0,
                    dispacthDelyvery:0,
                    dispacthPartials:0,
                    dispacthNotDelyvery:0,
                    fullCompliance:0,
                    warnings:"",
                    isDelete:  false,
                    isActive:  true,
                } 

                await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc('routedumy3').set(xpresssDriverRoutes1);
                //histoy
                await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc('routedumy3').collection('history').doc(Date.now().toString()).set(xpresssDriverRoutes1);    
                await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc('routedumy4').set(xpresssDriverRoutes2);
                //histoy
                await db.collection(`${process.env.REACT_APP_COL_ROUTES}`).doc('routedumy4').collection('history').doc(Date.now().toString()).set(xpresssDriverRoutes2);
               // console.log("Colleciones rutas  creada");
                  } catch (error) {
                 // console.log(error);
               }
        }



        // REACT_APP_COL_VEHICLES_TYPES=xpresssVehiclesTypes
        // REACT_APP_COL_VEHICLES=xpresssVehicles
        // REACT_APP_COL_ROUTES=xpresssDriverRoutes


    }


return (   <div className="bg-container ">
       <Container className='bodycontent'>
    <div>Instalador </div>
    <br></br>
    <table className="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Coleccion</th>
      <th scope="col">Actividad</th>
      <th scope="col">Acción</th>
    </tr>
  </thead>
  <tbody>
  <tr>
      <th>ALL</th>
      <td>Instalacion Recursiva</td>
      <td>
          <span className="alert alert-warning">Reinstalar todo</span>
          </td>
      <td><button value={'usuarios'} onClick={installerGlobalBsic}>Crear Tablas</button></td>
    </tr>
    <tr>
      <th>1</th>
      <td>{process.env.REACT_APP_COL_USERS}</td>
      <td>{
          usuarios===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'usuarios'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>#</th>
      <td>{process.env.REACT_APP_COL_ACCOUNTANS}</td>
      <td>{
          accountants===true===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'accountants'} onClick={createColleccionFirebase}>Reset All</button></td>
    </tr>
    <tr>
      <th>3</th>
      <td>{process.env.REACT_APP_COL_AVIABLEPLANS}</td>
      <td>{
          availableplans===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'availableplans'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>4</th>
      <td>{process.env.REACT_APP_COL_AVIABLE_ARTYPE}</td>
      <td>{
          availableservicesType===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'availableservicesType'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>#</th>
      <td>{process.env.REACT_APP_COL_CODESERVICES}</td>
      <td>{
          codeservices===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'codeservices'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>4</th>
      <td>{process.env.REACT_APP_COL_AVIABLE_SERVTYPE}</td>
      <td>{
          ServiceType===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'ServiceType'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
    
      <th>5</th>
      <td>{process.env.REACT_APP_COL_AVIABLE_SERV}</td>
      <td>{
          availableservices===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'availableservices'}  onClick={createColleccionFirebase} >Crear Dumy availableservices</button></td>
    </tr>
    <tr>
      <th>6</th>
      <td>{process.env.REACT_APP_COL_COMENTS}</td>
      <td>{
          coments===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'coments'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>7</th>
      <td>{process.env.REACT_APP_COL_COMPANIES}</td>
      <td>{
          companies===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'companies'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>8</th>
      <td>{process.env.REACT_APP_COL_CONTACTS}</td>
      <td>{
          contactsGlobal===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'contactsGlobal'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>9</th>
      <td>{process.env.REACT_APP_COL_ORDERS}</td>
      <td>{
          orders===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'orders'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>

    <tr>
      <th>9 - 1</th>
      <td>{process.env.REACT_APP_COL_VEHICLES_TYPES}</td>
      <td>{
          typesVehiclesTypes===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'VehiclesTypes'} onClick={createColleccionFirebase}>Crear Dumy types Vehicles</button></td>
    </tr>

    <tr>
      <th>9 - 2 </th>
      <td>{process.env.REACT_APP_COL_VEHICLES}</td>
      <td>{
          typesVehicles===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'xpresssVehicles'} onClick={createColleccionFirebase}>Crear Dumy Vehicles </button></td>
    </tr>

    <tr>
      <th>9 - 3 </th>
      <td>{process.env.REACT_APP_COL_ROUTES}</td>
      <td>{
          driversRoutes===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'xpresssDriverRoutes'} onClick={createColleccionFirebase}>Crear Dumy driversRoutes</button></td>
    </tr>

    <tr>
      <th>10</th>
      <td>{process.env.REACT_APP_COL_PAYMETHODS}</td>
      <td>{
          paymentmethods===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'paymentmethods'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>11</th>
      <td>{process.env.REACT_APP_COL_PAYOPTIONS}</td>
      <td>{
          paymentoptions===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'paymentoptions'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>12</th>
      <td>{process.env.REACT_APP_COL_PRODUCTS}</td>
      <td>{
          products===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'products'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>13</th>
      <td>{process.env.REACT_APP_COL_SUMARIES}</td>
      <td>{
          purchasesummaries===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'purchasesummaries'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>13</th>
      <td>{process.env.REACT_APP_COL_CARS}</td>
      <td>{
          cars===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'car'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>14</th>
      <td>{process.env.REACT_APP_COL_RATES}</td>
      <td>{
          rates===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'rates'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>    
    <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_ROLES}</td>
      <td>{
          roles===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'roles'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
     </tr>
      <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_BALANCE}</td>
      <td>{
          balance===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'shippingWalletBalance'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
      </tr>
      <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_BILLING}</td>
      <td>{
          billing===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'CompanybillingAccount'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
      </tr>
     
      <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_GLOBALBILLING}</td>
      <td>{
          globalBilling===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'GlobalsBillings'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
    </tr>
    <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_GLOBALBILLING} - history</td>
      <td>{
          GlobalBillinghistory===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'historyCompanybillingAccount'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
      </tr>
      <tr>
      <th>15</th>
      <td>{process.env.REACT_APP_COL_TYPEPACKS}</td>
      <td>{
          typesPackes===true?(<span className="alert alert-success">Activa</span>):(<span className="alert alert-danger">No existe</span>)
          }</td>
      <td><button value={'typesPackes'} onClick={createColleccionFirebase}>Crear Dumy</button></td>
      </tr>  
  </tbody>
</table>
</Container>
    </div>
  )
}

export default Installer